import {Component, Input} from '@angular/core';
import {SlideshowService} from '../slideshow.service';
import {ImagesService} from '../../shared/images.service';
import {MediaDialog} from '../images/media-dialog';
import { MatDialog } from '@angular/material/dialog';
import { GettyService } from '../../getty/getty.service';
import { Utils } from '../../utils';
import { MatDrawer } from '@angular/material/sidenav';
@Component({
    selector: 'writing-component',
    templateUrl: 'writing.component.html'
})
export class WritingComponent {
    imagesOpen = false;
    @Input('animationComplete') animationComplete;
    @Input('slideDrawer') public slideDrawer: MatDrawer;
    
    constructor(
        private dialog: MatDialog,
        public imagesService: ImagesService,
        public slideshow: SlideshowService,
        public gettyService: GettyService,
        public utils: Utils
    ) {}
    toggle(option) {
        this[option] = !this[option];
    }
    popImageDialog(image) {
        const dialog = this.dialog.open(MediaDialog, {
            panelClass: 'media-dialog',
            data: {
                image: image,
                canEdit: !this.slideshow.locked,
                quiz: this.slideshow.quiz
            }
        });
    }
}